import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

// výsledok dotazníka (typ, skóre, simulácia rizika) vyhodnotený a uložený na API
export function useInvestorAnalysisResult() {
  const client = useApiClientUser()

  const getInvestorAnalysisResult = async () => {
    const resp =
      await client.user.onboardingControllerGetInvestorAnalysisResult({
        secure: true,
      })
    return resp.data
  }

  const {
    error,
    isLoading,
    data: result,
  } = useQuery({
    queryKey: ['investorAnalysisResult'],
    queryFn: getInvestorAnalysisResult,
  })

  const errorMessage = getApiErrorMessage(
    error,
    'Výsledok dotazníka sa nepodarilo načítať.'
  )

  return {
    error: errorMessage,
    isLoading,
    result,
  }
}
